export default function HumanSilhouette({ gender = "male", className = "h-10 w-10" }) {
  if (gender === "female") {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path
          fillRule="evenodd"
          d="M12 2.2c-3.9 0-6.5 2.7-6.5 6.4 0 2.8.6 4.2.6 5.7 0 1.1-.6 1.9-1.7 2.6 1.8.9 3.5 1.1 4.7 1 .2.5.6.9 1.1 1.2-.9.4-1.7.6-2.6.7.5 1.2 1.6 2 3 2h2.8c1.4 0 2.5-.8 3-2-.9-.1-1.7-.3-2.6-.7.5-.3.9-.7 1.1-1.2 1.2.1 2.9-.1 4.7-1-1.1-.7-1.7-1.5-1.7-2.6 0-1.5.6-2.9.6-5.7 0-3.7-2.6-6.4-6.5-6.4zm0 3.2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"
        />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <circle cx="12" cy="7.2" r="3.9" />
      <path d="M3.8 21.5c0-4 3.7-6.3 8.2-6.3s8.2 2.3 8.2 6.3z" />
    </svg>
  );
}
